import { render, staticRenderFns } from "./PlaceLink.vue?vue&type=template&id=3aaa863d&"
import script from "./PlaceLink.vue?vue&type=script&lang=js&"
export * from "./PlaceLink.vue?vue&type=script&lang=js&"
import style0 from "./PlaceLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports